import { BrowserModule } from '@angular/platform-browser';
import {
  LOCALE_ID,
  NgModule,
  ErrorHandler, PLATFORM_ID,
} from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppRoutingModule } from './app-routing.module';
import { LoaderModule } from './app-shared/components/loader/loader.module';

import {
  TranslateModule,
  TranslateLoader,
} from '@ngx-translate/core';
import { TranslateSharedLazyModule } from './app-shared/modules/translate-shared-lazy.module';
import { MultiTranslateHttpLoader } from './app-shared/services/multi-http-loader.class';

import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import {
  APP_DATE_FORMATS,
  AppDateAdapter,
} from './app-shared/providers/date-adapter';

import { ServiceWorkerModule } from '@angular/service-worker';

import { CancelSameApisInterceptor } from './app-shared/services/http-interceptor.service';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import {isPlatformBrowser} from "@angular/common";


// ---------- TRANSLATE LOADER ----------
export function HttpLoaderFactory(httpClient: HttpClient) {
  return new MultiTranslateHttpLoader(httpClient, [
    { prefix: 'assets/i18n/', suffix: '_2_8_0.json' },
    { prefix: 'assets/i18n/currency/', suffix: '.json' },
    { prefix: 'assets/i18n/debs/debs-handler-1/', suffix: '.json' },
    { prefix: 'assets/i18n/', suffix: '_custom.json' },
  ]);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LoaderModule,

    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: false,
    }),

    CoreModule,
    TranslateSharedLazyModule.forRoot(),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      registrationStrategy: 'registerWhenStable:4000',
    }),
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'en-En' },

    { provide: DateAdapter, useClass: AppDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },

    { provide: HTTP_INTERCEPTORS, useClass: CancelSameApisInterceptor, multi: true },

    // Sentry Error Handler
    {
      provide: ErrorHandler,
      useFactory: (platformId: Object) => {
        if (isPlatformBrowser(platformId)) {
          return Sentry.createErrorHandler({
            logErrors: true,
          });
        }
        return {
          handleError(error: any): void {
            console.error('SSR Error:', error);
          },
        };
      },
      deps: [PLATFORM_ID],
    },

    // TraceService
    {
      provide: Sentry.TraceService,
      deps: [Router, PLATFORM_ID],
      useFactory: (router: Router, platformId: Object) => {
        if (isPlatformBrowser(platformId)) {
          return new Sentry.TraceService(router);
        }
        return null;
      },
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
